"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoRole = void 0;
var CognitoRole;
(function (CognitoRole) {
    CognitoRole["STUDENT"] = "student";
    CognitoRole["TEACHER"] = "teacher";
    CognitoRole["DISTRICT_ADMIN"] = "district-admin";
    CognitoRole["SCHOOL_ADMIN"] = "school-admin";
    CognitoRole["GM_DIS"] = "gm-dis";
    CognitoRole["GM_STAFF"] = "gm-staff";
    CognitoRole["GM_AUTHOR"] = "gm-author";
    CognitoRole["GM_SUPER"] = "gm-super-admin";
    CognitoRole["GM_DCST_AGENT"] = "gm-dcst";
    CognitoRole["GM_PS"] = "gm-ps";
})(CognitoRole || (exports.CognitoRole = CognitoRole = {}));
//# sourceMappingURL=cognito-role.enum.js.map